import {ReactNode} from 'react';
import { Button, ButtonProps, Tooltip, ButtonPropsSizeOverrides, Theme } from '@mui/material';
import {makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme : Theme) => ({
  root: {
    width: 'auto',
    height: 'auto',
    minWidth: 'unset',
    minHeight: 'unset',
    borderRadius: '50%',
    '& svg': {
      fontSize: 'inherit',
    },
    padding: ({size} : {size : ButtonPropsSizeOverrides}) => size === 'small' ? 6 : 8,
    fontSize: ({size} : {size : ButtonPropsSizeOverrides}) => size === 'medium' ? '1rem' : '',
    [theme.breakpoints.down('md')]: {
      fontSize: ({size} : {size : ButtonPropsSizeOverrides}) => size === 'small' ? '1.25rem' : '',
    }
  }
}), {name: 'IconButton'});

export type IconButtonProps = ButtonProps & {
  tooltip?: ReactNode;
  children: ReactNode;
};

const IconButton = ({children, tooltip, size = 'small', ...props} : IconButtonProps) : JSX.Element => {
  const classes = useStyles({size});
  return (
    <Tooltip title={tooltip && !props.disabled ? tooltip : ''}>
      <Button classes={classes} size={size} centerRipple {...props}>
        {children}
      </Button>
    </Tooltip>
  );
};

export default IconButton;